import React, {useState, useContext, useEffect} from "react";
import Box from "@mui/material/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@mui/material/Button";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {create} from "@api/barcodesLimit";
import Typography from "@mui/material/Typography";
import {renderForm, updateInfo} from "@components/Form/renderForm";
import {validation} from "@services/validation";
import {getTotalIssued} from "../../../../api/barcodes";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    main: {
        margin: '5px 0'
    }

});

export const CreateBarcodesLimit = ({data, handleClose}) => {
        const onCallback = (e) => {
            columns.forEach((column) => {
                if (column.name === e.target.name) {
                    column.value = e.target.value;
                    column.error = '';
                }
            })
            setColumns([...columns]);
        }
        const columnsData = [
            {name: 'amount', headerName: 'amount', type: 'number', value: 0, inputProps:{pattern: "[0-9]*{0,7}", max: 1000000}, onCallback: (e) => {
                const value = e.target.value
                if(value > 1000000) {
                    columns.forEach((column) => {
                        if (column.name === e.target.name) {
                            column.value = e.target.value;
                            column.error = 'Too much length';
                        }
                    })
                    setColumns([...columns]);
                } else {
                    onCallback(e)
                }
            }},
            {name: 'from', headerName: 'from', type: 'date', value: new Date(), momentObj: true, onCallback: onCallback},
            {name: 'until', headerName: 'until', type: 'date', value: new Date(), momentObj: true, onCallback: onCallback},
        ];

        const {benefitId} = data;
        const classes = useStyles();
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const [columns, setColumns] = useState(columnsData);
        const [statisticsObj, setStatisticsObj] = useState()

        const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            setErrorMessage(null);
            
            try {
                const data = new FormData(event.currentTarget);
                let obj = updateInfo(columns, data);
                if (benefitId) {
                    obj.benefitId = benefitId;
                }
                await create(obj);

                handleClose();
            } catch (e) {
                validation(e, columns, (columns) => {
                    return setColumns([...columns]);
                })
                setErrorMessage(e);
            }
            setLoading(false);
        }

        useEffect(() => {
            const loadCreatedBarcodeLimit = async () => {
                try {
                    setLoading(true);
                    setErrorMessage(null);
                    // eslint-disable-next-line no-unused-vars
                    const resObj = await getTotalIssued(benefitId)
                    setStatisticsObj(resObj)
                } catch (e) {
                    setErrorMessage(e);
                }
                setLoading(false);
            }

           loadCreatedBarcodeLimit();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [benefitId])

        return (
            <Box
                className={classes.root}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                component="form"
                flexDirection={"column"}
                onSubmit={handleSubmit}
                noValidate
            >

                {statisticsObj && statisticsObj.total && <Box> <Typography fontSize={22} component="h3">Total - {statisticsObj?.total}, issued
                    - {statisticsObj?.issued}</Typography></Box>}
                <Box
                    className={classes.main}
                >

                    {
                        columns.map((data, key) => {
                            return renderForm(data, key);
                        })
                    }
                </Box>
                <Button
                    type="submit"
                    variant="contained"
                >
                    Save
                </Button>
            </Box>
        );
    }
;